// extracted by mini-css-extract-plugin
export var actionText = "_sr-4";
export var container = "_sr-0";
export var leftSection = "_sr-1";
export var rightSection = "_sr-2";
export var settingsButton = "_sr-6";
export var settingsIcon = "_sr-7";
export var shortcut = "_sr-5";
export var shortcutGroup = "_sr-3";